import React, { useState } from "react";

import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import { Rules } from "@dashboard/users/rules/Rules";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { apiSend, getRoute } from "@services/axios";
import { success, error } from "@global/actions";

function FormNewUser(props) {
  const [loading, setLoading] = useState(false);

  const rules = new Rules(props.t);
  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      email: "",
      full_name: "",
      phone: "",
      address: "",
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const response = await apiSend(
      [getRoute("USER_RETRIEVE"), "create"].join("/"),
      "post",
      data
    );
    if (response?.data?.request?.code === 200) {
      success(response?.data?.result?.message);
    } else {
      if (response?.data?.result?.Error) {
        error(response?.data?.result?.Error);
      } else {
        error(response?.data?.result?.message);
      }
    }

    setLoading(false);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md="12">
          <p className="m-2 fw-bold">{props.t("name")}</p>
          <IController
            elment={`full_name`}
            item={rules.fullName()}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>
        <Col md="6">
          <p className="m-2 fw-bold">{props.t("email")}</p>
          <IController
            elment={`email`}
            item={rules.email()}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>
        <Col md="6">
          <p className="m-2 fw-bold">{props.t("phone")}</p>
          <IController
            elment={`phone`}
            item={rules.phone()}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>

        <Col md="12">
          <p className=" m-2 fw-bold">{props.t("address")}</p>
          <IController
            elment={`address`}
            item={rules.address()}
            control={control}
            errors={errors}
            register={register}
          />
        </Col>
        <Col md="12" className="mt-3">
          <Form
            as="button"
            type="submit"
            className="btn-blue p-3 rounded-3 fw-bold w-100"
          >
            {loading ? (
              <Form
                as="span"
                className="spinner-border spinner-border-sm m-1 "
              ></Form>
            ) : (
              props.t("add")
            )}
          </Form>
        </Col>
      </Row>
    </Form>
  );
}
export default FormNewUser;
